import React from 'react';
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import {useTranslation} from "react-i18next";
import Title from '../../../components/Title';
import Block from '../../../components/Block';
import ShowItem from '../../../components/ShowItem';
import {useDeleteDataVendorUserMutation, useGetDataVendorUserQuery} from '../../../api/dataVendorUserApiSlice';;
import * as Format from "../../../components/Format";
import {Icon} from "../../../components/components";
import {Button} from "react-bootstrap";
import useActionConfirmation from "../../../components/useActionConfirmation";

export default function DataVendorUser(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { dataVendorKey: dataVendorId, userId } = useParams();
  const {data: user, isSuccess} = useGetDataVendorUserQuery({dataVendorId, userId})
  const [deleteUser] = useDeleteDataVendorUserMutation()
  const rolePrefix = "data_vendor_"

  const {Confirmation, confirmationProps, confirm} = useActionConfirmation()

  const handleBack = () => history.push({
    pathname: `/data_vendors/${dataVendorId}/users`,
    state: {activeTab: 'users'}
  });

  const handleDelete = function() {
    deleteUser({dataVendorId, userId}).unwrap()
      .then(() => {
        history.push(`/data_vendors/${dataVendorId}/users`);
      })
  }

  if (!isSuccess) { return (<></>) }
  return (
    <>
      <Title main={t("menu.users")} sub={`${user.firstName} ${user.lastName}`} onBack={handleBack}>
        <Button onClick={() => history.push(`/data_vendors/${dataVendorId}/users/${userId}/edit`)}>
          <Icon icon='edit' text={t("edit")} />
        </Button>
        <Button onClick={() => confirm(handleDelete, user.lastName)}>
          <Icon icon='trash' text={t("delete")} />
        </Button>
      </Title>
      <Block>
        <ShowItem label={t("users.firstName")} value={user.firstName} />
        <ShowItem label={t("users.lastName")} value={user.lastName} />
        <ShowItem label={t("users.email")} value={user.email} />
        <ShowItem label={t("users.phoneNumber")} value={user.phoneNumber} />
        <ShowItem label={t("users.createdAt")}>
          <Format.Date date={user.createdAt} />
        </ShowItem>
        <ShowItem label={t("users.roles")} array value={user.roles.map(role => t("user."+role.replace(rolePrefix, '')))}/>
      </Block>
      <Confirmation placeholder="Please enter user last name" {...confirmationProps} deletion />
    </>
  )
}




